import Button from "@shared/v2/Button";
import Typography from "@shared/v2/Typography";
import { Section } from "../../../Reports/components/BusinessDashboard";

const SettingsHeader = () => {
  return (
    // @ts-expect-error props
    <Section className="tw-p-[8px]">
      <div className="tw-flex tw-justify-between tw-items-center tw-gap-[16px] tw-flex-wrap tw-min-h-[60px]">
        <h1 className="tw-pl-[16px] tw-m-0 tw-text-28d tw-font-normal">Phone System Settings</h1>
        <div className="tw-bg-white tw-p-[16px] tw-rounded-[8px] tw-border-solid tw-border-[1px] tw-border-gray-5 tw-flex tw-items-center tw-gap-[24px]">
          <div>
            {/* @ts-expect-error props */}
            <Typography variant="subtitle-s">Get the most from your Phone System</Typography>
            {/* @ts-expect-error props */}
            <Typography variant="body-s" className="tw-text-gray-50">
              Learn tips, tricks and industry best practices
            </Typography>
          </div>
          {/* @ts-expect-error props */}
          <Button
            schema="tertiary"
            className="tw-whitespace-nowrap"
            onClick={() =>
              window.open("https://www.brivityknowledge.com/docs/what-is-the-brivity-phone-system", "_blank")
            }
          >
            Learn More
          </Button>
        </div>
      </div>
    </Section>
  );
};

export default SettingsHeader;
